var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264 0c-24.9 0-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8c-30.9 0-56 25.1-56 56l0 200.8L95.6 256.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2L120.2 439.4C166.7 485.9 229.8 512 295.5 512l8.5 0c97.2 0 176-78.8 176-176l0-184c0-30.9-25.1-56-56-56c-8.6 0-16.7 1.9-24 5.4L400 88c0-30.9-25.1-56-56-56c-9.7 0-18.8 2.5-26.7 6.8C310 16.3 288.9 0 264 0zM184 64c13.3 0 24 10.7 24 24c0 0 0 0 0 .1L208 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0 0 0 0 0-.1L240 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32c0 0 0 0 0 .1L288 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-152.1C320 74.7 330.8 64 344 64c13.3 0 24 10.7 24 24l0 64c0 0 0 0 0 .1l0 87.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-88.1c0-13.2 10.8-23.9 24-23.9c13.3 0 24 10.7 24 24l0 184c0 79.5-64.5 144-144 144l-8.5 0c-57.3 0-112.2-22.8-152.7-63.3L39 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8L160 88c0-13.3 10.7-24 24-24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.da59b387edc33191c504de030e6c7ddd.svg";
export { ForwardRef as ReactComponent };